import React from "react";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import DivideByUnitPrice from "./DivideByUnitPrice";
import MemberPricePopover from "./MemberPricePopover";

interface Props {
  unitOfMeasure: string;
  platinumOrPlusPrice: number;
  regularPrice: number;
  isPlusMember: boolean;
  divideByUnit?: string;
  divideQuantity?: number;
  divideByUnitCssClass?: string;
}

const PlatinumPlusOverridePrice = ({
  unitOfMeasure,
  regularPrice,
  platinumOrPlusPrice,
  isPlusMember,
  divideByUnit,
  divideQuantity,
  divideByUnitCssClass,
}: Props) => {
  const renderDivideByUnitPrice = (price: number) => {
    if (!divideByUnit || divideByUnit?.length === 0) {
      return <></>;
    }
    if (!divideQuantity || divideQuantity <= 0) {
      return <></>;
    }

    return (
      <DivideByUnitPrice
        divideByUnit={divideByUnit}
        divideQuantity={divideQuantity}
        price={price}
        cssClass={divideByUnitCssClass ?? "text-xs block"}
      />
    );
  };
  return (
    <div className="map map-override">
      <div
        className={`map map-override ${
          isPlusMember ? "map--plus" : "map--platinum"
        }`}
      >
        <div className="map__group">
          <div
            className={`map__price ${
              isPlusMember ? "map__price--plus-member" : "map__price--platinum"
            }`}
            data-testid={`${isPlusMember ? "plus" : "platinum"}-member-price`}
          >
            <label className="price__label">
              {isPlusMember && <span className="plus-flag">Plus</span>}
              {`${isPlusMember ? " Member Price" : "Platinum Member Price"}`}
            </label>
            <div className="map__details">
              {isPlusMember ? (
                <MemberPricePopover
                  id="plusMemberPricePopover"
                  title="Plus Member Price"
                  content="Plus members get a sneak peek at this discounted price."
                />
              ) : (
                <MemberPricePopover
                  id="platinumMemberPricePopover"
                  title="Platinum Member Price"
                  content="Platinum members get a sneak peek at this discounted price."
                />
              )}
            </div>
            <p className="price">
              {formatAsCurrency.formatIfUndefined(platinumOrPlusPrice)}
              <span className="each">{`/${unitOfMeasure}`}</span>
              {renderDivideByUnitPrice(platinumOrPlusPrice)}
            </p>
          </div>
          <div className="map__text" data-testid="retail-price">
            <label className="price__label">Retail Price</label>
            <p className="text__enticement price before:content-none">
              <span className="line-through decoration-red-500 decoration-[3px]">
                {formatAsCurrency.formatIfUndefined(regularPrice)}
              </span>
              {renderDivideByUnitPrice(regularPrice)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatinumPlusOverridePrice;
